/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */

export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

export default async function getCroppedImgAsDataUrl(imageSrc, pixelCrop, rotation = 0, zoom = 1, aspect) {
  const image = await createImage(imageSrc);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const maxSize = Math.max(image.width, image.height);
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

  // set each dimensions to double largest dimension to allow for a safe area for the
  // image to rotate in without being clipped by canvas context
  canvas.width = safeArea;
  canvas.height = safeArea;

  // translate canvas context to a central location on image to allow rotating around the center.
  ctx.translate(safeArea / 2, safeArea / 2);
  ctx.rotate(getRadianAngle(rotation));
  ctx.translate(-safeArea / 2, -safeArea / 2);

  // draw rotated image and store data.
  ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);

  const data = ctx.getImageData(0, 0, safeArea, safeArea);

  // set canvas width to final desired crop size - this will clear existing context

  const additionalWidth =
    zoom < 1
      ? aspect === 1
        ? (image.width > image.height ? image.height : image.width) * (1 - zoom)
        : image.width * (1 - zoom)
      : 0;
  const additionalHeight =
    zoom < 1
      ? aspect === 1
        ? (image.width > image.height ? image.height : image.width) * (1 - zoom)
        : image.height * (1 - zoom)
      : 0;

  canvas.width =
    pixelCrop.width + (zoom < 0.5 ? additionalWidth * 4 : zoom < 1 ? additionalWidth * 2 : additionalWidth);
  canvas.height =
    pixelCrop.height + (zoom < 0.5 ? additionalHeight * 4 : zoom < 1 ? additionalHeight * 2 : additionalHeight);

  // paste generated rotate image with correct offsets for x,y crop values.

  const xCropping = zoom < 1 ? (canvas.width - image.width) / 2 : 0;
  const yCropping = zoom < 1 ? (canvas.height - image.height) / 2 : 0;

  ctx.putImageData(
    data,
    0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x + xCropping,
    0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y + yCropping
  );

  // As Base64 string
  return canvas.toDataURL("image/jpeg");

  // As a blob
  // return new Promise((resolve, reject) => {
  //   canvas.toBlob((file) => {
  //     resolve(URL.createObjectURL(file));
  //   }, "image/jpeg");
  // });
}

export const readFileAsDataUrl = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};
